/**
 * Registro de service worker — PWA Fase 1 (Roger 29-may-2026).
 *
 * Solo registra en producción. En localhost mostramos warning para indicar
 * que el SW no se activa en dev (CRA dev-server tiene su propio HMR).
 */

const isLocalhost = Boolean(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '[::1]'),
)

export function register(onUpdate) {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return
  if (isLocalhost) return

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing
          if (!installing) return
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              if (typeof onUpdate === 'function') onUpdate(registration)
            }
          }
        }
      })
      .catch(() => {})
  })
}

export function unregister() {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return
  navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {})
}
